module.exports = __webpack_public_path__ + "img/farmacia-municipal.754498eb.png";